import * as angular from 'angular';
import Card from "./card";
import CardPreview from "./preview/card.preview";
import CardActive from "./active/card.active";
import CardForm from "./form/card.form";
import CardService from "./card.service";
import CardDao from "./card.dao";
import CardMetadataDao from "./card.metadata.dao";

export default angular.module('CrazyWeb.Plans.Card', [])
    .component("card", Card)
    .component("cardPreview", CardPreview)
    .component("cardActive", CardActive)
    .component("cardForm", CardForm)
    .service("Card", CardDao)
    .service("CardMetadata", CardMetadataDao)
    .service("CardService", CardService).name
